import React from 'react';
import { MoreHorizontal } from 'lucide-react';

const Others = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <MoreHorizontal size={32} className="page-icon" />
        <h1 className="page-title">Others</h1>
      </div>
      <div className="page-content">
        <p className="page-description">Additional settings and options.</p>
        {/* Other features content will go here */}
      </div>
    </div>
  );
};

export default Others;